/**
 * @generated SignedSource<<1b50c74705b27aa13e478490219d85a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TopUpAiCreditsInput = {
  companyId: number;
  reason: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type topUpAiCreditsMutation$variables = {
  input: TopUpAiCreditsInput;
};
export type topUpAiCreditsMutation$data = {
  readonly TopUpAiCredits: {
    readonly success: boolean;
    readonly pack: string | null;
    readonly credits: number | null;
    readonly grantedBy: string | null;
    readonly grantedAt: string | null;
    readonly errorCode: string | null;
    readonly errorMessage: string | null;
  } | null;
};
export type topUpAiCreditsMutation = {
  variables: topUpAiCreditsMutation$variables;
  response: topUpAiCreditsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TopUpAiCreditsPayload",
    "kind": "LinkedField",
    "name": "TopUpAiCredits",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pack",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "credits",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "grantedBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "grantedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "topUpAiCreditsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "topUpAiCreditsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b4a1ee6356a4f79b31e48f36d47b6092",
    "id": null,
    "metadata": {},
    "name": "topUpAiCreditsMutation",
    "operationKind": "mutation",
    "text": "mutation topUpAiCreditsMutation(\n  $input: TopUpAiCreditsInput!\n) {\n  TopUpAiCredits(input: $input) {\n    success\n    pack\n    credits\n    grantedBy\n    grantedAt\n    errorCode\n    errorMessage\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab9c3a359655a634b188a4b700e5373c";

export default node;
